<template>
  <div class="profile-research">
    <profile-table-layout
      :title="'Публикации'"
      :get-items="api.person.profilePublications"
      entity="publications"
    >
      <template #table-item="slotProps">
        <profile-research-publication-item :item="slotProps.item" />
      </template>
    </profile-table-layout>
  </div>
</template>

<script setup>
  import ProfileTableLayout from '@/components/profile/ProfileTableLayout.vue';
  import ProfileResearchPublicationItem from '@/components/profile/research/ProfileResearchPublicationItem.vue';
  import { useApi } from '@/api/use-api';

  const api = useApi();
</script>

<style lang="scss" scoped>
@use "@/assets/styles/_colors.scss" as *;

  .profile-research {
    margin-top: 20px;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    row-gap: 10px;
    margin-bottom: 100px;
  }
</style>
